module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns-e0616ac8bf7514a29d18184456d4ce48.jpg";